export async function canvasToBlob(canvas: HTMLCanvasElement, type?: string, quality?: any): Promise<Blob | null> {
	return new Promise(resolve => {
		canvas.toBlob(b => resolve(b), type, quality)
	})
}
